import { TenantOrderLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import MlmJob from '../../model/MlmJob';
import MlmAerialConfig, { MlmAerialType } from './MlmAerialConfig';
import Big from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default class MlmAerialJob extends MlmJob<typeof MlmAerialConfig> {
  defaultValue(): ZodVersionedMetadata<(typeof MlmAerialConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      type: MlmAerialType.PHOTO,
    };
  }

  onsite() {
    let onsite = 30;

    if (this.metadata.type === MlmAerialType.BOTH) {
      onsite += 30;
    }

    return onsite;
  }

  get deliverable() {
    return DeliverableType.AERIAL;
  }

  get media() {
    return PersonaType.PROVIDER;
  }

  get performable() {
    return MlmAerialConfig;
  }

  get configurable() {
    return true;
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    lines.push({
      id: 'insurance',
      description: 'Government Mandated Drone Flight Insurance',
      amount: new Big(15),
    });

    if (this.metadata.type !== MlmAerialType.VIDEO) {
      lines.push({
        id: 'photos',
        description: 'Aerial Photography',
        amount: new Big(175),
      });
    }

    if (this.metadata.type !== MlmAerialType.PHOTO) {
      lines.push({
        id: 'video',
        description: 'Aerial Video',
        amount: new Big(175),
      });
    }

    return lines;
  }
}
